var _path, _rect, _circle, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadytolockicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5324 5.61044C10.803 4.18205 10.1941 1.2949 6.74338 1.00951C5.74351 0.926812 3.57235 1.34781 2.88672 3.69339V7.61771",
    stroke: "#2E77D0",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 8.32227,
    width: 11.6713,
    height: 7.9274,
    rx: 1.25,
    stroke: "#2E77D0",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.47292,
    cy: 11.7903,
    r: 0.75,
    stroke: "#2E77D0",
    strokeWidth: 0.529823
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.28136,
    y: 12.9064,
    width: 0.293197,
    height: 2.09748,
    stroke: "#2E77D0",
    strokeWidth: 0.293197
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadytolockicon);
export default __webpack_public_path__ + "static/media/readytolockicon.89c9abe11e005774fd0c624a9bc627b1.svg";
export { ForwardRef as ReactComponent };